module.exports = __webpack_public_path__ + "img/in.ina8b035d.svg";